import styled from '@emotion/styled';

import IconMail from '@assets/images/icons/icon-mail.svg';
import IconPhone from '@assets/images/icons/icon-phone.svg';

export const ContactWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: baseline;
	min-width: 0;

	@media ${({ theme }) => theme.medias.desktop} {
		flex-direction: row;
		align-items: center;
	}
`;

const defaultSpanLink = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.colors.gray3};
	min-width: 0;

	&:before {
		display: block;

		width: 16px;
		height: 16px;

		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;

		margin-right: 7px;
	}
`;

export const Email = styled(defaultSpanLink)`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	display: flex;
	align-items: center;

	&:before {
		min-width: 16px;
		min-height: 16px;
		content: '';
		background-image: url("${IconMail}");
	}

	@media screen and (max-width: 991px) {
		display: block;
		width: -webkit-fill-available;
		&:before {
			float: left;
		}
	}

`;

export const Phone = styled(defaultSpanLink)<{ loading?: number; error?: number }>`
	display: flex;
	align-items: center;
	&:before {
		${({ loading, error, theme }) =>
			!loading && !error
				? `
					content: '';
					background-image: url("${IconPhone}");
					background-position: left;

					@media ${theme.medias.desktop} {
						background-position: right;
						width: 27px;
					}`
				: `
		`}
		@media ${({ theme }) => theme.medias.desktop} {
			content: '|';
			margin: 0 8px;
			line-height: 16px;
			${({ error, loading }) => (error || loading ? 'width: auto;' : '')}
		}
	}

	${({ loading }) => loading && `img { width: 18px; }`}
`;

export const ShowPhone = styled.button`
	font-size: 12px;
	background: none;
	color: ${({ theme }) => theme.colors.primary1};
	font-weight: bold;
	min-width: 0;
	display: flex;

	img {
		width: 16px;
		cursor: default;
	}

	@media ${({ theme }) => theme.medias.desktop} {
		flex-shrink: 0;

		&:before {
			content: '|';
			font-weight: normal;
			color: ${({ theme }) => theme.colors.gray3};
			margin: 0 8px;
		}
	}
`;
